import React from 'react';
import * as actions from '../actions/currentNavigationMenuActionTypes';
import CIcon from '@coreui/icons-react'

const initialState = {
  navigationMenu: [
    {
      _tag: 'CSidebarNavItem',
      name: 'loading menu ...',
      to: '',
      icon: <CIcon name="cil-speedometer" customClasses="c-sidebar-nav-icon"/>    
    }
  ],
  navigationReload: true
}

function currentNavigationMenu(state = initialState, action) {      
  switch (action.type) {
    case actions.CURRENT_NAVIGATIONMENU_SET:
      return {
        ...state, 
        navigationMenu: action.navigationMenu
      }
    case actions.CURRENT_NAVIGATIONMENU_RELOAD:
      return {
        ...state, 
        navigationReload: action.navigationReload
      }
    default:        
      return state
  } 
}

export default  currentNavigationMenu;